// Handle SVG LazyLoading
export function setupLazyLoadSVG(panel = document) {
    const svgContainers = panel.querySelectorAll(".svg-container");
    const svgHiddenContainers = panel.querySelectorAll(".load-hidden-svg-containers");

    const svgHiddenContainerObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                loadSVGs(entry.target.querySelectorAll(".svg-container"));
            }
        });
    });

    svgHiddenContainers.forEach(container => svgHiddenContainerObserver.observe(container));

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) loadSVGs([entry.target]);
        });
    });

    svgContainers.forEach(container => observer.observe(container));

    // Function to load multiple SVGs
    function loadSVGs(containers) {
        containers.forEach(container => loadSVG(container));
    }

    function loadSVG(container) {
        const svgSrc = container.getAttribute("data-src");
        if (!svgSrc) return; // Exit if there's no data-src

        const classList = [...container.classList].filter(className => className !== "svg-container");
        const attributes = [...container.attributes].filter(attr => !['data-src', 'class'].includes(attr.name));

        getSvgContent(svgSrc)
            .then(svgContent => replaceContainer(container, svgContent, classList, attributes))
            .catch(error => console.error("Failed to load SVG:", error));
    }

    function setAttributesAndClasses(svgElement, classList, attributes) {
        svgElement.setAttribute("class", classList.join(" "));
        attributes.forEach(attr => svgElement.setAttribute(attr.name, attr.value));
    }

    function handleSvgScripts(svgElement) {
        const scriptElement = svgElement.querySelector('script');

        if (scriptElement) {
            const newScript = document.createElement('script');
            newScript.type = 'text/javascript';
            newScript.textContent = scriptElement.textContent.replace(/^<!\[CDATA\[|\]\]>$/g, '');
            document.head.append(newScript);
            newScript.remove();
        }
    }

    const svgCache = new Map();

    async function getSvgContent(url) {
        if (svgCache.has(url)) {
            return svgCache.get(url);
        }

        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const svgText = await response.text();
            const svgElement = new DOMParser().parseFromString(svgText, "image/svg+xml").documentElement;
            svgCache.set(url, svgElement);
            return svgElement;
        } catch (error) {
            console.error("Error fetching SVG:", error);
            svgCache.set(url, null);
            return null;
        }
    }

    function replaceContainer(container, svgContent, classList, attributes) {
        if (!svgContent) return;

        const svgElement = svgContent.cloneNode(true);
        setAttributesAndClasses(svgElement, classList, attributes);
        container.replaceWith(svgElement);
        handleSvgScripts(svgElement);
    }
}

window.addEventListener("load", () => setupLazyLoadSVG());